import {makeAutoObservable} from "mobx";
import {getStore, useStore} from "./index";

/**
 * @typedef {object} ConfirminitialConfig
 * @property {boolean?} isOpen
 * @property {string} title
 * @property {string} text
 * @property {function?} cancelFunc
 * @property {function?} closeFunc
 * @property {string} cancelText
 * @property {function} confirmFunc
 * @property {string} confirmText
 * @property {boolean?} textColor
 */

export class ConfirmStore {
    store;

    /** @type {ConfirminitialConfig} */
    initialConfig = {
        isOpen: false,
        title: "",
        text: "",
        cancelFunc: null,
        closeFunc: null,
        cancelText: "취소",
        confirmFunc: null,
        confirmText: "",
        textColor: null,
    };

    constructor(store) {
        this.store = store;
        makeAutoObservable(this, {}, {autoBind: true});
    }

    /**
     * 확인창을 오픈하는 함수
     * @param {ConfirminitialConfig} config 확인창 세팅 정보
     */
    openConfirm(config) {
        this.initialConfig = {
            isOpen: true,
            text: config.text,
            confirmFunc: config.confirmFunc,
            cancelFunc: config.cancelFunc || null,
            closeFunc: config.closeFunc || null,
            confirmText: config.confirmText,
            cancelText: config.cancelText || "취소",
            textColor: config.textColor || null,
            title: config.title,
        }
    }

    /**
     * 확인창을 종료할 때 초기화 시켜주는 함수
     */
    clear() {
        this.initialConfig = {
            isOpen: false,
            title: "",
            text: "",
            cancelFunc: null,
            closeFunc: null,
            cancelText: "취소",
            confirmFunc: null,
            confirmText: "",
        };
    }

}

export const useConfirmStore = () => {
    return useStore().confirmStore;
}

export const getConfirmStore = () => {
    return getStore().confirmStore;
}